import React from "react";

export default function Summary(props) {
    const {model, fullPriceOI} = props;

    return <div>
        <div className="details-row">
            <div>{model.itemsCount} товара на сумму</div>
            <div>{fullPriceOI} ₽</div>
        </div>

        {model.discount_percent ? <div className="details-row">
            <div>Скидка</div>
            <div>{parseFloat((fullPriceOI - model.product_sum) / fullPriceOI * 100).toFixed(2)} %</div>
        </div> : null}

        {model.promocodeDiscount ? <div className="details-row">
            <div className="flex">
                <span>Скидка по промокоду</span>
                &nbsp;
                <img className='details-row-question' src="/img/icons/question.svg" title='Скидка может применяться не на все товары и не работает на доставку' alt="question"/> 
            </div>
            <div>{model.promocodeDiscount} % </div>
        </div> : null}

        <div className="details-row">
            <div>Доставка</div>
            <div>{model.delivery_sum} ₽</div>
        </div>

        <hr/>

        <div className="details-row big">
            <div>Итоговая стоимость</div>
            <div>{model.sum} ₽</div>
        </div>
    </div>
}